import { c as _c } from "react/compiler-runtime";
import { IcoWarning16 } from '@onefootprint/icons';
import { getErrorMessage } from '@onefootprint/request';
type ErrorProps = {
  error: unknown;
};
const ErrorComponent = t0 => {
  const $ = _c(5);
  const {
    error
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IcoWarning16 />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== error) {
    t2 = getErrorMessage(error);
    $[1] = error;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="flex items-center md:ml-40">{t1}<p className="text-body-2 text-primary fp-text ml-1">{t2}</p></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default ErrorComponent;